module.exports = __webpack_public_path__ + "media/packs/src/assets/images/main-slide-img-2-b2d7eb141de8e8b71450730ccc105e6e.png";